const API_KEY = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
const BASE_URL = 'https://api.jobeng.ai';

const originalFetch = global.fetch;

global.fetch = function(url, options = {}) {
  // Only inject key for JobEng API calls
  if (typeof url === 'string' && url.includes('api.jobeng.ai')) {
    options.headers = {
      'Content-Type': 'application/json',
      'X-API-Key': API_KEY,
      ...options.headers,
    };
  }
  return originalFetch(url, options);
};

export { API_KEY, BASE_URL };
